module.exports = __webpack_public_path__ + "static/media/ogwugo-logo.bbe9337b.png";